import { BillingTariffInterface } from "../../../interfaces/BillingTarifInterface";

export const processTariff = (
  company: string,
  tariff: BillingTariffInterface,
): BillingTariffInterface => {
  const companyData = tariff.overrides?.[company] || tariff.data;
  return {
    ...tariff,
    companyData,
  };
};
